















import { Component, Vue, Prop } from 'vue-property-decorator';
import Lottie from '../Lottie.vue';
import bancadoAnimation from '../../assets/lottie/bancado.json';
import TitleMainDisplay from '../Text/TitleMainDisplay.vue';
import LinkSecondarySmall from '../Button/LinkSecondarySmall.vue';
import ChevronLeft from '../../assets/svg/chevron-left.svg';

@Component({
  components: {
    Lottie,
    TitleMainDisplay,
    LinkSecondarySmall,
    ChevronLeft,
  },
})
export default class MundoBancanteHeader extends Vue {
  @Prop() private bgColor!: string;

  @Prop() private goBackTo!: string;

  private bancadoAnimation: any;

  get getBgColor() {
    return this.bgColor || '#F6F6F6';
  }

  created() {
    this.bancadoAnimation = bancadoAnimation;

    const loading = document.getElementById('overlay-loading');
    if (!loading) return;
    const parent = loading.parentNode;
    if (parent) parent.removeChild(loading);
  }

  goBack() {
    this.$router.push({ name: this.goBackTo });
  }
}
